import React from 'react';
import PropTypes from 'prop-types';

import { patch } from 'helpers/api';
import AddToCallListDropdown from 'components/call_lists/add_to_call_list_dropdown';

/**
 * Context menu for a related contact on a research property
 */
export default class ContactRoleContextMenu extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callLists: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })),
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    contact: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      type: PropTypes.string
    }),
    contactRoleId: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    editContactRoleLink: PropTypes.string.isRequired
  };

  handlePrimary = (e) => {
    e.stopPropagation();
    const {
      contactRoleId
    } = this.props;

    patch(`/contacts/contact_roles/${contactRoleId}/make_primary`)
      .then(() => {
        window.buildout.refreshPropertyContact();
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.error('Unable to update primary contact');
      });
  }

  render() {
    const { 
      availableDatabases, 
      callLists, 
      contact,
      currentUser, 
      databaseMembers, 
      editContactRoleLink
    } = this.props;
    const contactType = contact.type === 'Contacts::Person' ? 'Contact' : 'Company';
    
    return (
      <React.Fragment>
        <div className="btn-group dropdown">
          <a data-toggle="dropdown" href="javascript:;">
            <i className="fas fa-cog fa-lg text-muted"></i>
          </a>
          <ul className="dropdown-menu" role="menu">
            <li role="presentation">
              <a className="js-modal-link" 
                data-inline="true" 
                data-title={`Edit Related ${contactType }`}
                href={editContactRoleLink}
              >
              Edit
              </a>
            </li>
            <li>
              <a className="clickable"
                name="make-primary"
                onClick={this.handlePrimary}
              >
                Make Primary
              </a>
            </li>
            {
              callLists && callLists.length > 0 &&
              <AddToCallListDropdown 
                availableDatabases={availableDatabases}
                callLists={callLists}
                contact={contact}
                currentUser={currentUser}
                databaseMembers={databaseMembers}
              />
            }
          </ul>
        </div>
      </React.Fragment>
    );
  }
}
